<template>
  <div id="description">
    <Wrap :title="title">
      <div class="box-title">
        <p>{{ $t("message.strid46") }}</p>
      </div>
      <div class="info-bar">
        Current Region: {{ _description.name }}
        <Button @click="backHome" type="border small float"
          >Reset Region</Button
        >
      </div>
      <ul class="des-box">
        <li
          class="item"
          v-for="(item, index) in _description.condition"
          :key="index"
        >
          <img src="@/assets/images/right.png" class="icon" alt="" />
          <p class="text">{{ item.value }}</p>
        </li>
      </ul>
    </Wrap>
    <Button type="active" @click="jump('law')">Qualified</Button>
    <Button type="border" @click="jumpForm"
      >Unqualified, need to customize</Button
    >
    <div class="blank"></div>
  </div>
</template>

<script>
import Wrap from "@/components/Wrap";
import Button from "@/components/Button";
import { mapState } from "vuex";
export default {
  components: {
    Wrap,
    Button
  },
  computed: {
    ...mapState(["_description"])
  },
  data() {
    return {
      title: "1"
    };
  },
  created() {
    if (!this._description.name) {
      this.$router.replace({ name: "law" });
    }
  },
  methods: {
    backHome() {
      this.$router.go(-1);
    },
    jump(name) {
      this.$router.push({ name });
    },
    jumpForm() {
      this.$router.push({
        name: "form",
        query: { c: this._description.id, t: 2 }
      });
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/description.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/description.scss";
}
</style>
